import Icon from '@mdi/react'
import styled, { css } from 'styled-components'

import { WhiteBlock } from 'components/Layout'
import { Font14 } from 'components/Typography'
import theme from 'theme_'
import {
  StyledBodyTr,
  TableWithPaginationWrapper,
} from 'components/Table/styles'

export const HomeDevicesTableInnerWrapper = styled.div`
  margin-top: 16px;
  @media ${theme.devices.tablet} {
    min-width: max-content;
    ${StyledBodyTr} {
      word-break: break-word;
    }
  }
`

export const HomeDevicesTableOuterWrapper = styled(TableWithPaginationWrapper)`
  @media ${theme.devices.tablet} {
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    margin-bottom: 8px;
  }
`

export const HomeDevicesComponentCell = styled.div`
  font-weight: 900;
  width: 100%;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

export const HomeDevicesTypeCell = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
`

export const HomeDevicesRowStyles = css`
  height: auto;
  min-height: 40px;
  align-items: center;
`

export const HomeDevicesCard = styled(WhiteBlock)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.s};
  padding: ${theme.spacing.base};
`

export const HomeDevicesCardRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const HomeDevicesCardTitle = styled.span`
  font-weight: bold;
  ${Font14}
`

export const HomeDevicesFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.base};
`

export const StyledIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const HomeDevicesCardInfoName = styled.div`
  color: ${theme.colors.darkeyGrey};
`

export const HomeDevicesCardInfoValue = styled.div`
  color: ${theme.colors.otterWarmBlack};
`
